import { getTimezoneOffset as calculateTimezoneOffset } from './date-service'
import { TimeZone, TimeZoneDatabaseNames } from '../api-client/enums/timezone'

export default function getTimezoneOffset(timeZone, date) {
  if (timeZone === TimeZone.None) return 0

  const offset = calculateTimezoneOffset(TimeZoneDatabaseNames[timeZone], date)

  return Math.floor((offset / (1000 * 60 * 60)) % 24)
}
